import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@instructure/ui-buttons';
import { TextInput } from '@instructure/ui-text-input';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import themeable from '@instructure/ui-themeable';
import { SAVING } from '../../../constants/CaptureStates';
import { translate } from '../../../constants/translated/translations';
var styles = {
  componentId: 'YDWjL',
  template: function template(theme) {
    return "\n\n.YDWjL_defB{width:100%}\n\n.YDWjL_crZr{display:flex;width:100%}";
  },
  'form': 'YDWjL_defB',
  'container': 'YDWjL_crZr'
};
/**
---
private: true
---
**/

var FileSave = (_dec = themeable(function () {}, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FileSave, _Component);

  function FileSave(props) {
    var _this;

    _classCallCheck(this, FileSave);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileSave).call(this, props));

    _this.onChange = function () {
      _this.setState({
        fileName: _this.input.value
      });
    };

    _this.saveClicked = function (e) {
      e.preventDefault();

      _this.props.actions.saveClicked(_this.state.fileName.trim());
    };

    _this.state = {
      fileName: _this.props.fileName
    };
    return _this;
  }

  _createClass(FileSave, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("form", {
        className: styles.form
      }, React.createElement("div", {
        className: styles.container
      }, React.createElement(TextInput, {
        size: "small",
        label: React.createElement(ScreenReaderContent, null, translate('SR_FILE_INPUT')),
        placeholder: this.props.fileName,
        onChange: this.onChange,
        inputRef: function inputRef(e) {
          _this2.input = e;
        }
      }), React.createElement(Button, {
        type: "submit",
        onClick: this.saveClicked,
        disabled: this.props.captureState === SAVING,
        variant: "primary",
        size: "small",
        margin: "0 0 0 x-small"
      }, translate('SAVE'))));
    }
  }]);

  FileSave.displayName = "FileSave";
  return FileSave;
}(Component), _class2.propTypes = {
  captureState: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    saveClicked: PropTypes.func.isRequired
  }).isRequired
}, _temp)) || _class);
export { FileSave as default };